import { render, staticRenderFns } from "./TextFieldRef.vue?vue&type=template&id=4840a5be&"
import script from "./TextFieldRef.vue?vue&type=script&lang=js&"
export * from "./TextFieldRef.vue?vue&type=script&lang=js&"
import style0 from "./TextFieldRef.vue?vue&type=style&index=0&id=4840a5be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
